import React from 'react'
import Container from '@mui/material/Container'
import { authContext } from '../../../contexts/AuthContext'
import _ from 'lodash'
import {
  Breadcrumbs,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import { Box } from '@mui/system'
import DeleteDialog from '../../DeleteDialog'
import AssignedLawyersCard from './AssignedLawyersCard'
import FeaturesCard from './FeaturesCard'
import UserAdmins from './UserAdmins'
import ClientNavigation from '../../ClientNavigation'
import ClientTitle from '../../ClientTitle'
import { withTranslation } from 'react-i18next'
import { PropTypes } from 'prop-types'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import CPDeleteIconButton from '../../Utils/CPDeleteIconButton'
import CPEditIconButton from '../../Utils/CPEditIconButton'
import AssignedWorkspacesCard from './AssignedWorkspacesCard'
import ClientUsers from './ClientUsers'
import { AssignedSocietiesCard } from '../ClienteDetalle/AssignedSocietiesCard'
import { apiUrl } from '../../../config/api'
import ClientWorkspaceDialog from './ClientWorkspaceDialog'

class Administracion extends React.Component {
  // Pagina de configuracion de cada cliente

  constructor() {
    super()

    this.state = {
      client: {},
      selectedClientDetail: {},
      companies: [],
      addClient: {},
      clientSettings: {},
      editClient: {},
      deleteClient: {},
      remountKey: 0,
      updateNavTo: null
    }
  }

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  static contextType = authContext

  handleAddClientOpen = (client) => {
    this.setState({
      addClient: client
    })
  }

  handleClientSettingsOpen = (client) => {
    this.setState({ clientSettings: client })
  }

  handleEditClientOpen = (client) => {
    this.setState({
      editClient: client
    })
  }

  handleDeleteClientOpen = (client) => {
    this.setState({
      deleteClient: client
    })
  }

  handleDialogClose = () => {
    this.setState({
      addClient: {},
      clientSettings: {},
      editClient: {},
      deleteClient: {}
    })
  }

  updateClient = (client) => {
    client.name = document.getElementById('edit_name').value
    client.license = document.getElementById('edit_license').value
    client.loggedUserId = this.context.auth.user.id
    client.brandLabel = window.$brand

    let url = apiUrl('UpdateClient')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(client)
    })
      .then((res) => console.log(res))
      .then(() => {
        console.log('Update successful')
        if (client.id === this.state.client.id) {
          this.setState({
            client: {
              ...this.state.client,
              name: client.name,
              license: client.license
            }
          })
        }
        this.fetchClientList()
        this.handleDialogClose()
      })
      .catch((error) => console.log(error))

    this.handleDialogClose()
  }

  deleteClient = (client) => {
    client.loggedUserId = this.context.auth.user.id
    client.brandLabel = window.$brand

    let url = apiUrl('DeleteClient')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(client)
    })
      .then((res) => console.log(res))
      .then(() => {
        console.log('Delete successful')

        this.fetchClientList()
        this.handleDialogClose()
      })
      .catch((error) => console.log(error))
  }

  insertClient = (client) => {
    client.name = document.getElementById('insert_name').value
    client.license = document.getElementById('insert_license').value
    client.workspaceId = this.state.client.workspace_id
    client.loggedUserId = this.context.auth.user.id
    client.brandLabel = window.$brand

    let url = apiUrl('InsertClient')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(client)
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('Insert successful')
        this.handleDialogClose()
        this.fetchClientList()
      })
      .catch((error) => console.log(error))
  }

  componentDidMount() {
    const navClient = this.props.location.state.client
    this.setState({
      client: navClient,
      selectedClientDetail: navClient
    })
    this.fetchClient(navClient.id)
    this.fetchClientList()
  }

  fetchClient = (id) => {
    fetch(apiUrl('GetClientDataById'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientId: id })
    })
      .then((res) => res.json())
      .then((client) => {
        this.setState({ client, selectedClientDetail: client })
      })
      .catch((error) => console.log(error))
  }

  fetchClientList = () => {
    let params = {
      parent: this.props.location.state.client.id,
      brandLabel: window.$brand
    }

    let url = apiUrl('ListClientsByParent')

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(params)
    })
      .then((response) => response.json())
      .then((companies) => {
        _.forEach(companies, (company) => {
          params.parent = company.id

          fetch(url, {
            method: 'POST',
            body: JSON.stringify(params)
          })
            .then((response) => response.json())
            .then((areas) => {
              _.find(companies, { id: company.id }).areas = areas
              company.areas = areas
              this.forceUpdate()
            })
        })
        this.setState({
          companies: companies
        })
      })
  }

  updateClientNavigation = (scd) => {
    this.setState({
      selectedClientDetail: scd
    })
  }

  DirectoryRow = ({
    t,
    icon,
    label,
    meta,
    onSettings,
    onEdit,
    onDelete,
    idx
  }) => (
    <Box
      key={idx}
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 2,
        py: 1.25,
        borderBottom: '1px solid',
        borderColor: 'divider',
        cursor: 'default',
        borderLeft: '3px solid transparent',
        bgcolor: 'transparent',
        '&:hover': { bgcolor: 'action.hover' },
        transition: 'background 0.1s'
      }}
    >
      <Box
        sx={{
          color: 'text.secondary',
          display: 'flex',
          mr: 1.5,
          flexShrink: 0
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flexGrow: 1, minWidth: 0 }}>
        <Typography variant='body2' noWrap fontWeight={500}>
          {label}
        </Typography>
        {meta && (
          <Typography
            variant='caption'
            noWrap
            sx={{
              color: 'text.secondary'
            }}
          >
            {meta}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', gap: 0.5, ml: 1, flexShrink: 0 }}>
        {/* {onSettings && (
          <Tooltip title={t('Settings')}>
            <IconButton size='small' onClick={onSettings}>
              <SettingsOutlinedIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        )} */}
        {onEdit && (
          <Tooltip title={t('Edit')}>
            <IconButton size='small' onClick={onEdit}>
              <EditOutlinedIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        )}
        {onDelete && (
          <Tooltip title={t('Delete')}>
            <IconButton
              size='small'
              sx={{ color: '#d32f2f' }}
              onClick={onDelete}
            >
              <DeleteOutlinedIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  )

  render() {
    const { t } = this.props

    return (
      <Container maxWidth='lg' sx={{ mt: 0, mb: 4 }}>
        <Button
          sx={{
            m: 3,
            backgroundColor: window.$brand === 'PRB' ? '#17afb6' : '#102a46',
            borderRadius: window.$brand === 'PRB' ? 0 : 5
          }}
          variant='contained'
          onClick={() => {
            let client = this.state.client
            this.props.history.push({
              pathname: `/client/${client.id}`,
              state: { client: client }
            })
          }}
        >
          {window.$brand === 'ZAP'
            ? t('go_to_condo')
            : window.$brand === 'IDB'
              ? t('go_to_clientTransactions')
              : t('go_to_client')}
        </Button>
        <Box
          sx={{
            px: 2,
            py: 1.25,
            borderBottom: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: 1,
            bgcolor: 'background.paper'
          }}
        >
          <Breadcrumbs
            separator='›'
            sx={{
              flexGrow: 1,
              minWidth: 0,
              overflow: 'hidden',
              '& .MuiBreadcrumbs-ol': { flexWrap: 'nowrap' },
              '& .MuiBreadcrumbs-li': { minWidth: 0 }
            }}
          >
            <Typography
              variant='body2'
              fontWeight={600}
              color='text.primary'
              noWrap
            >
              {t('Directory')}
            </Typography>
          </Breadcrumbs>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              flexShrink: 0,
              flexWrap: 'wrap',
              justifyContent: { xs: 'flex-end', sm: 'flex-start' }
            }}
          >
            <Button
              variant='contained'
              startIcon={<AddIcon />}
              size='small'
              sx={{
                bgcolor: window.$brand === 'PRB' ? '#17afb6' : '#102a46',
                borderRadius: window.$brand === 'PRB' ? 0 : 2,
                flexShrink: 0
              }}
              onClick={() =>
                this.handleAddClientOpen({
                  type: 'company',
                  parent: this.state.client.id,
                  id: '-1'
                })
              }
            >
              {t('Add')}{' '}
              {window.$brand === 'ZAP'
                ? t('property')
                : window.$brand === 'IDB'
                  ? t('Financings')
                  : t('company')}
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
            overflow: 'hidden',
            position: 'relative',
            bgcolor: 'background.paper'
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              overflowY: 'auto',
              minWidth: 0,
              maxWidth: '100vw'
            }}
          >
            <Box sx={{ px: 2, pt: 2, pb: 0.5 }}>
              <Typography
                variant='caption'
                color='text.secondary'
                fontWeight={600}
              >
                {window.$brand === 'ZAP' ? t('Condominium') : t('Client')}
              </Typography>
            </Box>
            {this.DirectoryRow({
              t,
              icon: <FolderOutlinedIcon fontSize='small' />,
              label: this.state.client.name,
              meta: this.state.client.license
                ? `ID: ${this.state.client.license}`
                : undefined,
              onSettings: () =>
                this.handleClientSettingsOpen(this.state.client),
              onEdit: () => this.handleEditClientOpen(this.state.client),
              idx: -1
            })}
            {this.state.companies && this.state.companies.length > 0 && (
              <>
                <Box sx={{ px: 2, pt: 2, pb: 0.5 }}>
                  <Typography
                    variant='caption'
                    color='text.secondary'
                    fontWeight={600}
                  >
                    {window.$brand === 'ZAP'
                      ? t('Properties')
                      : window.$brand === 'IDB'
                        ? t('Financings')
                        : t('Companies')}
                  </Typography>
                </Box>
                {this.state.companies.map((company, idx) =>
                  this.DirectoryRow({
                    t,
                    icon: <FolderOutlinedIcon fontSize='small' />,
                    label: company.name,
                    meta: company.license
                      ? `ID: ${company.license}`
                      : undefined,
                    onSettings: () => this.handleClientSettingsOpen(company),
                    onEdit: () => this.handleEditClientOpen(company),
                    onDelete: () => this.handleDeleteClientOpen(company),
                    idx
                  })
                )}
              </>
            )}
          </Box>
        </Box>

        <Box sx={{ mt: 4 }}>
          <AssignedWorkspacesCard client={this.props.location.state.client} />
        </Box>
        {/* TODO UPDATE */}
        {/* {window.$brand === 'PRB' && (
          <Box sx={{ mt: 4, maxWidth: 400 }}>
            <AssignedSocietiesCard
              clientId={this.state.client.id}
              adminMode={true}
            />
          </Box>
        )} */}
        <Grid container spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <UserAdmins clientId={this.props.location.state.client.id} />
          </Grid>
          <Grid item xs={12} md={6}>
            <ClientUsers clientId={this.props.location.state.client.id} />
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <AssignedLawyersCard client={this.props.location.state.client} />
          </Grid>
          {window.$brand === 'PRB' && (
            <Grid item xs={12} md={6}>
              <FeaturesCard client={this.props.location.state.client} />
            </Grid>
          )}
        </Grid>

        <DeleteDialog
          item={this.state.deleteClient}
          title={
            t('Delete') +
            ' ' +
            (this.state.selectedClientDetail.type === 'client'
              ? t('business')
              : this.state.selectedClientDetail.type === 'company'
                ? t('company')
                : t('area'))
          }
          caption={
            t('delete_client_caption') +
            (this.state.selectedClientDetail.type === 'client'
              ? t('business')
              : this.state.selectedClientDetail.type === 'company'
                ? t('company')
                : t('area')) +
            '?'
          }
          targetFunc={this.deleteClient}
          handleDialogClose={this.handleDialogClose}
        />
        {!_.isEmpty(this.state.clientSettings) && (
          <ClientWorkspaceDialog
            open={!_.isEmpty(this.state.clientSettings)}
            onClose={this.handleDialogClose}
            client={this.state.clientSettings}
          />
        )}
        <Dialog
          open={!_.isEmpty(this.state.editClient)}
          onClose={this.handleDialogClose}
        >
          <DialogTitle>
            {t('Update')}{' '}
            {this.state.selectedClientDetail.type === 'client'
              ? t('business')
              : this.state.selectedClientDetail.type === 'company'
                ? t('company')
                : t('area')}
          </DialogTitle>
          <DialogContent>
            <TextField
              required
              id='edit_name'
              label={t('Name')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.editClient.name}
              inputProps={{ maxLength: 50 }}
            />
            <TextField
              id='edit_license'
              label={t('ID')}
              type='text'
              fullWidth
              variant='standard'
              defaultValue={this.state.editClient.license}
              inputProps={{ maxLength: 20 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose}>{t('Cancel')}</Button>
            <Button onClick={() => this.updateClient(this.state.editClient)}>
              {t('Save')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={!_.isEmpty(this.state.addClient)}
          onClose={this.handleDialogClose}
        >
          <DialogTitle>
            {t('Add')}{' '}
            {this.state.addClient.type === 'company'
              ? t('company')
              : window.$brand === 'IDB'
                ? t('Financings')
                : t('area')}
          </DialogTitle>
          <DialogContent>
            <TextField
              required
              id='insert_name'
              label={t('Name')}
              type='text'
              fullWidth
              variant='standard'
              inputProps={{ maxLength: 50 }}
            />
            <TextField
              id='insert_license'
              label={t('ID')}
              type='text'
              fullWidth
              variant='standard'
              inputProps={{ maxLength: 20 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose}>{t('Cancel')}</Button>
            <Button onClick={() => this.insertClient(this.state.addClient)}>
              {t('Save')}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    )
  }
}

export default withTranslation()(Administracion)
